module.exports = __webpack_public_path__ + "static/img/product2.fa2507e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/purple/product2.png
// module id = K23d
// module chunks = 0